export const environment = {
  production: false,
  // apiUrl: 'http://192.168.2.30:8008/api',
  // apiUrl: 'http://localhost:5000/api',
  apiUrl: 'https://apirep.usibras.com/api',
};
